var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
const liHtml = (extClass) => html `
  <li class="list-menu-item-li ${extClass}">
    <span class="list-menu-sample-text"></span>
  </li>
`;
const liHtmls = (extClass = '') => [
    liHtml(extClass),
    liHtml(extClass),
    liHtml(extClass),
];
let ExEditorListStylePaletteElement = class ExEditorListStylePaletteElement extends LitElement {
    connectedCallback() {
        super.connectedCallback();
    }
    handleListTypeClick(listType) {
        this.dispatchEvent(new CustomEvent('pick', { detail: listType }));
    }
    getListHtml(listType, listStyleType) {
        // 无序列表为 unicode 的时候，样式值需要用引号包裹
        const isUnicode = /\d/.test(listStyleType);
        return listType === 'ul'
            ? html `
          <ul
            class="list-menu-item-ul"
            style="list-style-type: ${isUnicode
                ? `'${listStyleType}'`
                : listStyleType};"
          >
            ${liHtmls(isUnicode ? 'unicode' : '')}
          </ul>
        `
            : html `
          <ol
            class="list-menu-item-ul"
            style="list-style-type: ${listStyleType};"
          >
            ${liHtmls()}
          </ol>
        `;
    }
    render() {
        return html `
      <div>
        ${this.listStyleTypes.map((row) => html `
            <div class="row-flex">
              ${row.map((listStyleType) => html `
                  <div
                    class="
                  list-menu-item
                  toolbar-grid-container
                  ${listStyleType === this.listStyleType
            ? 'toolbar-grid-container-selected'
            : ''}
                "
                    @mousedown=${(e) => {
            e.preventDefault();
        }}
                    @click=${() => {
            this.handleListTypeClick(listStyleType);
        }}
                  >
                    ${this.getListHtml(this.listType, listStyleType)}
                  </div>
                `)}
            </div>
          `)}
      </div>
    `;
    }
};
ExEditorListStylePaletteElement.styles = [
    css `
      :host {
        display: block;
        padding: 8px;
      }
      .list-template {
        padding: 7px;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        box-shadow: 0 2px 12px 2px rgb(68 73 77 / 16%);
        border-radius: 2px;
      }
      .row-flex {
        display: flex;
        justify-content: flex-start;
        gap: 8px;
        margin-bottom: 8px;
      }
      .row-flex:last-child {
        margin-bottom: 0px;
      }
      .toolbar-grid-container {
        background-color: #fff;
        border-radius: 1px;
        border-style: solid;
        border-width: 1px;
        border-color: rgba(0, 0, 0, 0.12);
      }
      .toolbar-grid-container:hover {
        box-shadow: 0 0 6px 0 rgb(0 0 0 / 12%);
        transition: box-shadow 0.3s cubic-bezier(0.25, 0.1, 0.29, 0.93);
      }
      .toolbar-grid-container-selected {
        border: 1px solid rgba(0, 0, 0, 0.64);
      }
      .list-menu-item {
        height: 60px;
        width: 60px;
        font-size: 11px;
        color: rgba(0, 0, 0, 0.88);
        line-height: 14px;
        user-select: none;
        cursor: pointer;
        padding: 9px;
        border-radius: 4px;
      }

      .list-menu-item .list-menu-sample {
        display: flex;
        align-items: center;
        padding-bottom: 5px;
      }

      .list-menu-item .list-menu-item-ul {
        padding-left: 12px;
        margin-top: 5px;
      }

      .list-menu-item .list-menu-item-li {
        height: 18px;
      }

      .list-menu-item .list-menu-item-li.unicode {
        margin-left: -4px;
        padding-left: 4px;
      }

      .list-menu-item .list-menu-sample-text {
        position: relative;
        top: -2px;
        flex: 1;
        display: inline-block;
        height: 3px;
        width: 100%;
        background: #e1e3e5;
      }
    `,
];
__decorate([
    property({
        attribute: true,
    })
], ExEditorListStylePaletteElement.prototype, "listType", void 0);
__decorate([
    property({
        attribute: true,
        reflect: true,
    })
], ExEditorListStylePaletteElement.prototype, "listStyleType", void 0);
__decorate([
    property({
        attribute: true,
    })
], ExEditorListStylePaletteElement.prototype, "listStyleTypes", void 0);
ExEditorListStylePaletteElement = __decorate([
    customElement('exeditor-list-style-palette')
], ExEditorListStylePaletteElement);
export { ExEditorListStylePaletteElement };
//# sourceMappingURL=list-style-palette.js.map